import { Component, Input } from "@angular/core";
import { GatewayView } from "../gateway-view";
import { Gateway } from "@impulse/sdp-shared-models";

@Component({
	selector: "sdp-gateway-table-hosts",
	template: `<p *ngFor="let host of hosts">{{ host }}</p>`
})
export class GatewayTableHostsComponent {
	@Input()
	public gateway?: GatewayView;

	/**
	 * @returns an array of just the hosts from the private gateway, or an empty array if no such data is mapped to this component
	 */
	public get hosts(): Gateway.Host[] {
		if (!!this.gateway && !!this.gateway.hostAndPorts) {
			return this.gateway.hostAndPorts.map((hostAndPort) => {
				return hostAndPort.host;
			});
		} else {
			return [];
		}
	}
}
